export default __webpack_public_path__ + "media/projects/blue2-thumb-81962a69.svg";